import { ADD_FEATURE_FLAGS } from '../actions/constants';

const featureFlags = (state = {}, action) => {
    if (action.type === ADD_FEATURE_FLAGS) {
        return {
            ...state,
            ...action.featureFlags,
        };
    }

    return state;
};

export default featureFlags;
